var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.5h-4a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm-3.479-1h2.958c-.105-1.186-.6-2-1.479-2-.88 0-1.374.814-1.479 2zm3.967.081A1.5 1.5 0 0 1 21.5 17v2a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.012-1.419c.103-1.738.865-3.081 2.488-3.081s2.385 1.343 2.488 3.081zM9.69 10.863a4.5 4.5 0 1 1 4.62 0 7.469 7.469 0 0 1 2.018 1.01.5.5 0 0 1-.578.817A6.5 6.5 0 0 0 5.5 18c0 .817 2.62 1.5 6.5 1.5.094 0 .211 0 .51.003l.308.002c.397.003.665.001.8-.005a.5.5 0 0 1 .045 1c-.16.007-.436.008-.851.005-.158 0-.158 0-.31-.002A68.981 68.981 0 0 0 12 20.5c-4.524 0-7.5-.776-7.5-2.5a7.503 7.503 0 0 1 5.19-7.137zM12 10.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPermission);
export default __webpack_public_path__ + "static/media/UserPermission.14eaa868bc7b8cae36029530d9f6a548.svg";
export { ForwardRef as ReactComponent };